import extend from "lodash/extend";
import $ from "jquery";
import EventEmitter from "events";

let _promise;
let _emitter = new EventEmitter();

class Profile {
	constructor(json) {
		extend(this, json);
		this.id = json.id;
		this.username = json.username;
		this.membership = json.membership;
	}

	isStaff(exclusive = false) {
		return !!this.staff_id;
	}

	isBasic(exclusive = false) {
		return Profile.isBasic(this.membership, exclusive);
	}

	isPrime(exclusive = false) {
		return Profile.isPrime(this.membership, exclusive);
	}

	isAdfree(exclusive = false) {
		return Profile.isAdfree(this.membership, exclusive);
	}

	isInside(exclusive = false) {
		return Profile.isInside(this.membership, exclusive);
	}

	static BASIC = "basic";
	static PRIME = "prime";
	static ADFREE = "adfree";
	static INSIDE = "inside";
	static STAFF = "staff";

	static isInside(id, exclusive = false) {
		return id === Profile.INSIDE || id === Profile.STAFF;
	}

	static isAdfree(id, exclusive = false) {
		if (id === Profile.ADFREE) {
			return true;
		}

		return !exclusive ? this.isInside(id, exclusive) : false;
	}

	static isPrime(id, exclusive = false) {
		if (id === Profile.PRIME || id === Profile.STAFF) {
			return true;
		}

		return !exclusive ? this.isAdfree(id, exclusive) : false;
	}

	static isStaff(id) {
		return id === Profile.STAFF;
	}

	static isBasic(id) {
		return this.isUser && !this.isPrime(id);
	}

	get isUser() {
		return !!this.id; //null or 0 is anonymous, cast to bool
	}
}

export default function getProfile() {
	return (_promise =
		_promise ||
		$.ajax({
			method: "POST",
			url: `https://${document.location.hostname}/whoami`,
			xhrFields: { withCredentials: true },
			crossDomain: true,
			dataType: "json",
		}).then((json) => {
			const profile = new Profile(json);
			window.tpm_profile = profile;
			return profile;
		}));
}

export function refreshProfile() {
	_promise = null;
	document.cookie = `_uscb=${Date.now()};path=/`;
	return getProfile().then((profile) => {
		_emitter.emit("refresh", profile);
		return profile;
	});
}

export function onRefresh(callback) {
	_emitter.addListener("refresh", callback);
}
